<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card style="overflow: hidden;">
        <v-card-title>
          <span v-if="text == 'cancel'" class="font-20">หมายเหตุการยกเลิกนัดหมาย</span>
          <span v-else class="font-20">รายละเอียดการยกเลิกนัดหมาย</span>
        </v-card-title>
        <v-card-text v-if="text == 'cancel'" class="pb-0">
          <v-form ref="notes">
            <v-textarea
              color="#00A99D"
              solo
              dense
              row="3"
              v-model="note"
              hide-details="auto"
              placeholder="กรุณากรอกหมายเหตุการยกเลิกนัดหมาย"
              :rules="rule_note"
            >
            </v-textarea>
          </v-form>
        </v-card-text>
        <v-card-text v-else class="pb-0">
            <v-textarea
              color="#00A99D"
              solo
              dense
              row="3"
              v-model="note"
              hide-details="auto"
              readonly
            >
            </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-row class="mx-0" v-if="text == 'cancel'">
            <v-col cols="6" class="py-5 pl-2">
              <v-btn
                outlined
                block
                color="#FF8082"
                @click="(dialog = false), (note = '')"
                style="border-radius: 20px 5px;"
                >ยกเลิก</v-btn
              >
            </v-col>
            <v-col cols="6" class="py-5 pr-2">
              <v-btn
                block
                dark
                depressed
                color="#00A99D"
                @click="confirmCancel()"
                style="border-radius: 20px 5px;"
                >บันทึก</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-else class="mx-0" justify="center">
            <v-col cols="6" class="py-5 pl-2">
              <v-btn
                outlined
                block
                color="#FF8082"
                @click="(dialog = false)"
                style="border-radius: 20px 5px;"
                >ปิด</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Sweetdialog ref="sweetDialog" />
  </div>
</template>

<script>
import Sweetdialog from "../Telepharma/Sweetdialog.vue";
import moment from "moment";

export default {
  components: {
    Sweetdialog,
  },
  data() {
    return {
      dialog: false,
      data: "",
      text: "",
      deliveryDrug: "",
      patientList: "",
      note: "",
      rule_note: [(v) => !!v || "กรุณากรอกเหตุผลการยกเลิก"],
    };
  },
  methods: {
    openDialog(item, text) {
      console.log('item', item);
      this.dialog = true;
      this.data = item;
      this.text = text
      this.note = ''

      if ('note_cancel' in item && item.note_cancel !== '' && item.note_cancel !== null && item.note_cancel !== undefined) {
        this.note = item.note_cancel
      }
    },
    confirmCancel() {
      this.$swal
        .fire({
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการยืนยันยกเลิกนัดหมาย</span>",
          html: "<span style='color: black;font-size: 16px;font-family: Sarabun;'>" + this.data.fullname + "<br /> วันที่ " + moment(this.data.slot_date).locale("th").format("DD MMMM YYYY") + "</span>",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText:
            "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          cancelButtonColor: "#FFFFFF",
          showConfirmButton: true,
          confirmButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.cancel();
          } else if (result.isDenied) {
            this.dialog = false
            this.note = ''
          }
        });
    },
    async cancel() {
      if (!this.$refs.notes.validate()) {
        const data = {
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>กรุณากรอกเหตุผลการยกเลิก</span>",
          icon: "error",
          showConfirmButton: false,
          confirmButtonText: "ปิด",
          confirmButtonColor: "#00A99D",
          timer: 1500,
        };
        this.$refs.sweetDialog.open(data);
        return;
      } else {
        console.log('item', this.data || '-');
        console.log('reason :', this.note);

        try {
          var params = new URLSearchParams()
          params.append('appointment_id', this.data.appointment_id)
          params.append('userqr_id', this.data.userqr_id)
          params.append('biz_id', sessionStorage.getItem('biz_id'))
          params.append('account_id', sessionStorage.getItem("account_id"))

          await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/cancel_home_visit?${params}`,
            {
              note: this.note
            },
            ).then((res) => {
              console.log('res cancel', res);
              if (res.data.result === "success" && res.data.code === 200) {
                this.$swal({
                  title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ยกเลิกนัดหมายสำเร็จ</span>",
                  icon: "success",
                  showConfirmButton: false,
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#00A99D",
                }).then(() => {
                  this.dialog = false
                  this.note = ''
                  this.$emit("close")
                  this.$emit("status_type", 'CancelBooking')
                  this.$refs.notes.resetValidation();
                })
              } else {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ยกเลิกนัดหมายไม่สำเร็จ</span>",
                  icon: "error",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                  timer: 3000,
                }).then(() => {
                   this.$refs.notes.resetValidation();
                })
              }
            })
        } catch (error) {
          console.log('error', error);
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
</style>
